import { SystemMessages } from 'utils/enums/system-message.enum'
import { realNameFieldSchema } from 'utils/schema.util'
import { z } from 'zod'

export const teenagerFilterSchema = z.object({
  dataNascimento: z.string().nullish(),
  documento: z.string().max(50, SystemMessages.MESSAGE_MAX_SIZE_50).nullish(),
  nome: z.string().nullish(),
  nomeSocial: z.string().nullish(),
  nomeMae: realNameFieldSchema.nullish(),
  nomePai: realNameFieldSchema.nullish(),
  genero: z.string().max(60, SystemMessages.MESSAGE_MAX_SIZE_60).nullish(),
  representanteLegal: realNameFieldSchema.nullish(),
})

export const summaryTeenagerSchema = z.object({
  id: z.number(),
  idOitiva: z.number(),
  nome: z.string(),
  nomeSocial: z.string(),
  dataNascimento: z.string(),
  genero: z.string().nullish(),
})

export type TeenagerFilterType = z.infer<typeof teenagerFilterSchema>

export type SummaryTeenagerType = z.infer<typeof summaryTeenagerSchema>

export const teenagerFilterInit: TeenagerFilterType = {
  nome: '',
  nomeSocial: '',
  nomeMae: '',
  nomePai: '',
  dataNascimento: '',
  documento: '',
  representanteLegal: '',
}
